export const DETECTED = "DETECTED";
export const SA_AGE = "SA_AGE";
export const GEO_IP = "GEO_IP";
export const SA_COUNTRY = "SA_COUNTRY";
export const SITE_COUNTRY = "SITE_COUNTRY";
